// Func = limiting Scope for this file
var lastScrollTop = 0;
document.addEventListener("DOMContentLoaded", DOMReady);
(function(){

	$(document).ready(function () {

		// Main Nav Dropdown
		$("#primary-nav li").hover(function(){
			$(this).addClass("hover");
			$('ul.submenu',this).fadeIn(200);
		}, function(){
			$(this).removeClass("hover");
			$('ul.submenu',this).fadeOut(200);
		});

		//Properties Day's Calendar [Enable/Disable,ClassName,Tooltip]
		let DATE_STYLE = [true];
		function calendarRange(date){			
			let d1=$.datepicker.parseDate(DATE_FORMAT,$('#CheckIn').val());		
			let d2=$.datepicker.parseDate(DATE_FORMAT,$('#CheckOut').val());
			if (d1 && date.getTime() == d1.getTime() || d2 && date.getTime() == d2.getTime()) {
				DATE_STYLE[1] = 'highlight-top';
			}else if(date > d1 && date < d2){
				DATE_STYLE[1] = 'highlight';
			}else{
				DATE_STYLE[1] = '';
			}
			return DATE_STYLE;
		}

		//Check in and check out datepicker for booking engine
		const DATE_FORMAT = ($("#CheckIn").data("format") !== undefined && $("#CheckIn").data("format")) ? $("#CheckIn").data("format") : "yy-mm-dd";		
        $( "#CheckIn" ).datepicker({
			changeMonth: true,
            dateFormat: DATE_FORMAT,
            numberOfMonths: 1,
			minDate: 0,
			beforeShowDay: (date) => calendarRange(date),
			onSelect: function( selectedDate ) {
				let getDate = $(this).datepicker('getDate');
				let newDate = new Date(getDate.getTime());
				newDate.setDate(newDate.getDate() + 3);
				$( "#CheckOut" ).datepicker( "setDate", newDate );
				$( "#CheckOut" ).datepicker( "option", "minDate", selectedDate );
			}
		});
		$( "#CheckOut" ).datepicker({
            dateFormat: DATE_FORMAT,
            changeMonth: true,
			numberOfMonths: 1,
			beforeShowDay: (date) => calendarRange(date)
		});


 
	// ------- Sliders SWIPER -------
	const swiperClass = ".swiperJs"; 
	const swiperOps = {
		uniqueNavElements: false,
		loop: true,
		speed: 1400,
		effect: 'fade',
		fadeEffect: {
		crossFade: true,
		},
		navigation: {
		nextEl: '.sw-arrow.sw-button-prev',
		prevEl: '.sw-arrow.sw-button-next'
		},
		autoplay: {
			delay: 5000,
			disableOnInteraction: false
		},
	};
	
	document.querySelectorAll(swiperClass).forEach((element,i) => {

        let swiperConfig = element.dataset.swiper ? JSON.parse(element.dataset.swiper): swiperOps;
        element.setAttribute(`data-swiper-${i}`,"")
		let swiper = new Swiper(`[data-swiper-${i}]`, swiperConfig);

		 
		// start count custom
		customcount(`[data-swiper-${i}] ${swiperConfig.customcount}`);
		swiper.on('slideChange', () => {
			// //refresh count cutom
			// let galleryGlob = document.querySelector('.countSpan');
			document.querySelectorAll(`.countSpan`).forEach((element) =>{
				element.innerHTML = `${swiper.realIndex +1}`   ;
           
			});
			document.querySelectorAll(`[data-swiper-${i}] .counter`).forEach((element) =>{
				element.innerHTML = `0${swiper.realIndex +1}`   ;
           
			});
		});

        //add custom count 
        function customcount(element){
            let countcontainerall= document.querySelectorAll(element);
            countcontainerall.forEach((element) =>{
                let addstring =`<span class="counter">${swiper.realIndex + 1} </span>
                                                <span class="count-line"></span>
                                                <span class="total-count">0${swiper.slidesEl.childElementCount}</span>`;
                element.innerHTML = addstring;
            });
        }

	});



  	// ------- end Sliders ----------


	});

	window.onload = function() {
		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
		})
	};

}());

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		if (st > lastScrollTop){
			// downscroll code
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if(!document.getElementById('header').classList.contains('up')){
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}
// Dom Ready Funtion
function DOMReady() {

    "use strict";

	// ------- Init  Lenis Scroll  -------
	const lenis = new Lenis()

	lenis.on('scroll', (e) => {
	//   console.log(e)
	})
	
	function raf(time) {
		lenis.raf(time)
		requestAnimationFrame(raf)
	}
	
	requestAnimationFrame(raf)
	// ------- End Init  Lenis Scroll -------


	// ------- email signup animation  -------
	if(document.getElementById('email-signup_email_address') || document.getElementById('email-signup_email_address')){
		document.getElementById('email-signup_FNAME').addEventListener('focus', function(){
			this.parentElement.classList.add('moved');
		})
		document.getElementById('email-signup_LNAME').addEventListener('focus', function(){
			this.parentElement.classList.add('moved');
		})
		document.getElementById('email-signup_email_address').addEventListener('focus', function(){
			this.parentElement.classList.add('moved');
		}) 

		//Form Contact animation 
		function attachEvents(elementList, eventName, handlerFunction) {
			if(typeof elementList == "string")
					elementList = document.querySelectorAll(elementList);
			for(var i = 0; i < elementList.length; i++)
					elementList[i].addEventListener(eventName, handlerFunction);
		}
		attachEvents(".form-module-wrapper input", "click", function(event) {
				this.parentElement.classList.add('moved');
		});
		attachEvents(".form-module-wrapper textarea", "click", function(event) {
				this.parentElement.classList.add('moved');
		});
		attachEvents(".form-module-wrapper select", "click", function(event) {
				this.parentElement.classList.add('moved');
				document.querySelector('select[name="lead[referral_source_id]"]').size=1;
		});
		attachEvents("#tripleseat_embed_form textarea", "click", function(event) {
				this.parentElement.classList.add('moved');
		});
		attachEvents("#tripleseat_embed_form label", "click", function(event) {
				this.parentElement.classList.add('moved');
		});
		attachEvents("#tripleseat_embed_form select", "click", function(event) {
				this.parentElement.classList.add('moved');
				document.querySelector('select[name="your_wedding_season"]').size=1;
		});
	}
	// ------- End email signup animation -------

	
	// ------- Remove Required Input type checkbox Form Footer  -------
	document.querySelector('#email-signup input[name="subscribe"]').classList.remove('required');
	 //Select value in 0
	 if (document.querySelector('select[name="your_wedding_season"]')) {
		setTimeout(() => {
			document.querySelector('select[name="your_wedding_season"]').value = '0';
		 }, 1000);
	 }
	 if (document.querySelector('select[name="lead[referral_source_id]"]')) {
		setTimeout(() => {
			document.querySelector('select[name="lead[referral_source_id]"]').value = '0';
		 }, 1000);
	 }
	// ------- End Remove Required Input type checkbox Form Footer -------

	// ------- CTA Header - Scroll down to the bottom form  -------
	if(document.querySelector('.planning-btn-js')){
		document.querySelectorAll('.planning-btn-js').forEach((btn, i) => {
			btn.addEventListener('click', _ => {
				let top_ele = $('#tripleseat_embed_form').offset().top;
				$('html,body').animate({scrollTop:top_ele-100},2000).delay(1200);
			});
			// if (i === 0) btn.click();
		});
    };
	// ------- End CTA Header - Scroll down to the bottom form -------

	// ------- tablet / mobile menu cta -------
	if(document.getElementById('menu-sm-cta-js')){
		let menuMobile = document.getElementById('box-primary-nav');
		document.getElementById('menu-sm-cta-js').addEventListener('click', function(e){
			e.preventDefault();
			if(menuMobile.classList.contains('closed')){
				console.log('sali');
				document.getElementById('box-primary-nav').classList.remove('closed');
				this.classList.remove('closed');
				document.getElementById('menutext-js').innerHTML = 'Close';
				document.getElementById('header').classList.add('open-menu');
				document.querySelector("body").classList.add('noScroll')
				if(lastScrollTop < 80){
					document.getElementById('header').classList.remove('open-menu');
				}
			} else {
				console.log('entre');
				document.getElementById('box-primary-nav').classList.add('closed');
				this.classList.add('closed');
				document.getElementById('menutext-js').innerHTML = 'Menu';
				document.querySelector("body").classList.remove('noScroll');
			}
		});
	}
	// ------- End tablet / mobile menu cta -------
}
